"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCdn = isCdn;
exports.splitNameAndExtension = splitNameAndExtension;
exports.getType = getType;
exports.isImage = isImage;
exports.canPreviewLocalFile = canPreviewLocalFile;
exports.getIsVideoSelectedForUpload = getIsVideoSelectedForUpload;
exports.getIsDocumentSelectedForUpload = getIsDocumentSelectedForUpload;
exports.convertUrlToDomain = convertUrlToDomain;
exports.findAndReplaceHostingInfo = findAndReplaceHostingInfo;
exports.getUpdatedPlayerIdVideoFile = getUpdatedPlayerIdVideoFile;
exports.softDeleteVidyardPlayerIdFromFile = softDeleteVidyardPlayerIdFromFile;
exports.getFileType = getFileType;
exports.getIsImage = getIsImage;
exports.getIsVideo = getIsVideo;
exports.getIsSvg = getIsSvg;
exports.getHasThumbnail = getHasThumbnail;
exports.getImageSrc = getImageSrc;
exports.getResizedFilePreviewUrl = getResizedFilePreviewUrl;
exports.getResizedFileThumbnailUrl = getResizedFileThumbnailUrl;
exports.isAnimation = isAnimation;
exports.getIsFileManagerUrl = getIsFileManagerUrl;
exports.getShouldRenderFileUrl = getShouldRenderFileUrl;
exports.getCdnHostnameForEnv = exports.getFileDetailsFileManagerAppLink = exports.getIsSvgTooLarge = exports.getIsFileBeingReplaced = exports.getIsTemporaryUploadingFile = void 0;

var _Url = _interopRequireDefault(require("urlinator/Url"));

var _params = require("hub-http/helpers/params");

var _Constants = require("../Constants");

var _CdnHostnames = _interopRequireDefault(require("../enums/CdnHostnames"));

var _cdnHostnames = require("../utils/cdnHostnames");

var _hubLVideo = require("./hubLVideo");

var _image = require("./image");

var _immutable = _interopRequireDefault(require("immutable"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _thumbnailUrls = require("./thumbnailUrls");

var _resize = require("./resize");

var _fileAccessibility = require("./fileAccessibility");

var _fileSizes = require("../constants/fileSizes");

var ThumbnailSizes = _interopRequireWildcard(require("../enums/ThumbnailSizes"));

var HUBFS_CDN_URL_REGEX = /\/hubfs\/([0-9]+)\/(.*)/;
var HUBFS_DOMAIN_URL_REGEX = /\/hubfs\/(.*)/;
var LEGACY_CDN_URL_REGEX = /\/hub\/([0-9]+)\/(.*)/;
var LEGACY_DOMAIN_URL_REGEX = /\/hs-fs\/(.*)/;
var FREE_PAGE_BUILDER_QA_HOSTNAME = 'hubspotpagebuilderqa.com';
var FREE_PAGE_BUILDER_HOSTNAME = 'hubspotpagebuilder.com';

function isCdn(hostname) {
  return _CdnHostnames.default.includes(hostname) || hostname.endsWith("." + FREE_PAGE_BUILDER_QA_HOSTNAME) || hostname.endsWith("." + FREE_PAGE_BUILDER_HOSTNAME);
}

function splitNameAndExtension(file) {
  var name = file.name; // eslint-disable-next-line no-useless-escape

  var matches = name.match(/(.*)\.([^\.]+)$/);

  if (!matches) {
    return {
      extension: '',
      name: name
    };
  }

  return {
    name: matches[1],
    extension: matches[2].toLowerCase()
  };
}

function getType(extension) {
  var type = _Constants.TypeToExtensions.findKey(function (extensions) {
    return extensions.includes(extension);
  });

  if (type) {
    return type;
  }

  return _Constants.FileTypes.OTHER;
}

function isImage(file) {
  return file.type && file.type.indexOf('image/') === 0;
}

function canPreviewLocalFile(localFile) {
  var _splitNameAndExtensio = splitNameAndExtension(localFile),
      extension = _splitNameAndExtensio.extension;

  return isImage(localFile) && extension !== 'svg';
}

function getIsVideoSelectedForUpload(file) {
  return file.type && file.type.indexOf('video/') === 0;
}

function getIsDocumentSelectedForUpload(file) {
  var _splitNameAndExtensio2 = splitNameAndExtension(file),
      extension = _splitNameAndExtensio2.extension;

  return file.type && _Constants.TypeToExtensions.get(_Constants.FileTypes.DOCUMENT).includes(extension);
}

function convertUrlToDomain(file, domain) {
  var url = file.get('url');
  var parsed = new _Url.default(url);
  var nextHostname = domain.get('domain');
  var pathname = parsed.pathname;

  var urlScheme = file.getIn(['meta', 'url_scheme']) || _Constants.UrlSchemes.LEGACY;

  if (!domain) {
    return file.get('url');
  }

  if (parsed.hostname === nextHostname) {
    return file.get('url');
  }

  var updates = {
    protocol: domain.get('isSslEnabled') ? 'https' : 'http',
    hostname: nextHostname
  };

  if (isCdn(parsed.hostname) && !isCdn(nextHostname)) {
    if (urlScheme === _Constants.UrlSchemes.SIMPLIFIED) {
      var matches = pathname.match(HUBFS_CDN_URL_REGEX);

      if (matches && matches.length) {
        updates.pathname = "/hubfs/" + matches[2];
      }
    } else {
      var _matches = pathname.match(LEGACY_CDN_URL_REGEX);

      if (_matches && _matches.length) {
        updates.pathname = "/hs-fs/" + _matches[2];
      }
    }
  } else if (!isCdn(parsed.hostname) && isCdn(nextHostname)) {
    if (urlScheme === _Constants.UrlSchemes.SIMPLIFIED) {
      var _matches2 = pathname.match(HUBFS_DOMAIN_URL_REGEX);

      if (_matches2 && _matches2.length) {
        updates.pathname = "/hubfs/" + file.get('portal_id') + "/" + _matches2[1];
      }
    } else {
      var _matches3 = pathname.match(LEGACY_DOMAIN_URL_REGEX);

      if (_matches3 && _matches3.length) {
        updates.pathname = "/hub/" + file.get('portal_id') + "/" + _matches3[1];
      }
    }
  }

  parsed.update(updates);
  return parsed.href;
}

function findAndReplaceHostingInfo(file, hostingInfoReplacement) {
  if (file.getIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO)) {
    return file.getIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO).map(function (hostingInfo) {
      if (hostingInfo.get('provider') === hostingInfoReplacement.get('provider')) {
        return hostingInfoReplacement;
      }

      return hostingInfo;
    });
  }

  return _immutable.default.List([hostingInfoReplacement]);
}

function getUpdatedPlayerIdVideoFile(file, newHostingInfo) {
  return file.setIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO, findAndReplaceHostingInfo(file, newHostingInfo));
}

function softDeleteVidyardPlayerIdFromFile(file, oldPlayerId) {
  return file.setIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO, findAndReplaceHostingInfo(file, _immutable.default.Map({
    provider: _Constants.VideoProviders.VIDYARD,
    status: 'DISABLED',
    id: oldPlayerId
  })));
}

function getFileType(file) {
  if (file.get('type')) {
    return file.get('type');
  }

  return getType(file.get('extension'));
}

function getIsImage(file) {
  return getFileType(file) === _Constants.FileTypes.IMG;
}

function getIsVideo(file) {
  return getFileType(file) === _Constants.FileTypes.MOVIE;
}

function getIsSvg(file) {
  return getIsImage(file) && file.get('encoding') === 'svg';
}

var getIsTemporaryUploadingFile = function getIsTemporaryUploadingFile(file) {
  return file.get('id') <= 0;
};

exports.getIsTemporaryUploadingFile = getIsTemporaryUploadingFile;

var getIsFileBeingReplaced = function getIsFileBeingReplaced(file) {
  return file.has('progress') && !getIsTemporaryUploadingFile(file);
};

exports.getIsFileBeingReplaced = getIsFileBeingReplaced;

var getIsSvgTooLarge = function getIsSvgTooLarge(file) {
  return file.get('size') >= _fileSizes.BYTES_IN_MEGABYTE;
};

exports.getIsSvgTooLarge = getIsSvgTooLarge;

function getHasThumbnail(file) {
  if (getIsSvg(file) && (getIsSvgTooLarge(file) || getIsTemporaryUploadingFile(file))) {
    return false;
  }

  if ((0, _fileAccessibility.getIsFileExternal)(file)) {
    return false;
  }

  var type = getFileType(file);
  return type === _Constants.FileTypes.IMG || type === _Constants.FileTypes.MOVIE;
}

function getImageSrc(file, thumbSize, options) {
  if (file.has('tempUrl')) {
    return file.get('tempUrl');
  }

  if (file.has('progress')) {
    return file.get('url');
  }

  if (file.get('encoding') === 'svg' && !(0, _fileAccessibility.getIsFilePrivate)(file)) {
    return file.get('friendly_url');
  }

  return (0, _thumbnailUrls.getVideoOrImageThumbnailUrl)(file, thumbSize, options);
}

function getResizedFilePreviewUrl(file, imageWidth) {
  var url = file.get('default_hosting_url');

  if (getIsVideo(file)) {
    return getImageSrc(file, ThumbnailSizes.MEDIUM, {
      noCache: true
    });
  }

  if ((0, _fileAccessibility.getIsFilePrivate)(file)) {
    return (0, _thumbnailUrls.getPrivateThumbnailRedirectUrl)(file, ThumbnailSizes.MEDIUM, {
      noCache: true
    });
  } // temp fix to load large image thumbs (JIRA: https://issues.hubspotcentral.com/browse/CG-16539)


  if ((0, _resize.getIsFileTooLargeForResizing)(file)) {
    return getImageSrc(file, ThumbnailSizes.MEDIUM, {
      noCache: true
    });
  }

  if (file.has('tempUrl')) {
    return file.get('tempUrl');
  }

  if (file.has('progress')) {
    return url;
  }

  url = url + "?t=" + file.get('updated');

  if (file.get('replaced')) {
    return url;
  }

  return (0, _resize.resize)(url, {
    // 2x width for retina
    width: imageWidth * 2
  });
}

function getResizedFileThumbnailUrl(file, imageWidth) {
  var url = file.get('default_hosting_url');

  if ((0, _fileAccessibility.getIsFilePrivate)(file)) {
    return (0, _thumbnailUrls.getPrivateThumbnailRedirectUrl)(file, ThumbnailSizes.MEDIUM);
  }

  if (getIsVideo(file)) {
    return getImageSrc(file, ThumbnailSizes.MEDIUM, {
      noCache: true
    });
  } // temp fix to load large image thumbs (JIRA: https://issues.hubspotcentral.com/browse/CG-16539)


  if ((0, _resize.getIsFileTooLargeForResizing)(file)) {
    return getImageSrc(file, ThumbnailSizes.MEDIUM);
  }

  if (file.has('tempUrl')) {
    return file.get('tempUrl');
  }

  if (file.has('progress')) {
    return url;
  }

  if (file.get('encoding') === 'svg') {
    return file.get('default_hosting_url');
  }

  if (url && !url.includes('?')) {
    url = url + "?t=" + file.get('updated');
  }

  if (file.get('replaced')) {
    return url;
  }

  return (0, _resize.resize)(url, {
    width: imageWidth
  });
}

function isAnimation(file) {
  return file.getIn(['meta', 'animated']) || false;
}

function getIsFileManagerUrl(url) {
  var parsed = new _Url.default(url);
  var pathname = parsed.pathname;
  var matches = pathname.match(HUBFS_CDN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  matches = pathname.match(HUBFS_DOMAIN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  matches = pathname.match(LEGACY_CDN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  matches = pathname.match(LEGACY_DOMAIN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  return false;
}

var getFileDetailsFileManagerAppLink = function getFileDetailsFileManagerAppLink(file) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  queryParams[_Constants.FILE_DETAILS_QUERY_PARAM_NAME] = file.get('id');
  return "/files/" + _PortalIdParser.default.get() + "?" + (0, _params.stringify)(queryParams);
};

exports.getFileDetailsFileManagerAppLink = getFileDetailsFileManagerAppLink;

function getShouldRenderFileUrl(_ref) {
  var file = _ref.file;

  switch (getFileType(file)) {
    case _Constants.FileTypes.IMG:
      return !(0, _image.isShutterstock)(file) && file.get('url') && !file.get('temp');

    case _Constants.FileTypes.MOVIE:
      return !(0, _hubLVideo.isHubLVideo)(file.toJS());

    default:
      return true;
  }
}

var getCdnHostnameForEnv = _cdnHostnames.getCdnHostnameForPortal;
exports.getCdnHostnameForEnv = getCdnHostnameForEnv;